import React, { useCallback, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "../Styles/CardPartido.css"; // Asegúrate de que esta ruta sea correcta
import { ModalUtil } from "../../ModalUtil/Components/ModalUtilComponent";
import { PlanillarPartidoComponent } from "./PlanillarPartidoComponent";
import { EstadisticasPartidoComponent } from "./EstadisticasPartidoComponent";
import axios from "axios";
import { BASE_URL } from "../../../config";
import { useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

const CardPartidos = () => {
  const { idTorneo } = useParams();
  const [escenarios, setEscenarios] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPartidoId, setSelectedPartidoId] = useState(null);
  const [selectedEquipoId, setSelectedEquipoId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 6;
  const [showModal, setShowModal] = useState(false);
  const [showModalEstadisticas, setShowModalEstadisticas] = useState(false);
  const [partidos, setPartidos] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [fecha, setFecha] = useState("");
  const [horaInicial, setHoraInicial] = useState("");
  const [horaFinal, setHoraFinal] = useState("");
  const [escenarioSeleccionado, setEscenarioSeleccionado] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseModalEstadisticas = () => {
    setShowModalEstadisticas(false);
  };

  const obtenerPartidos = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}get-partidos-torneo/${idTorneo}`
      );
      const partidosConDetalles = response.data.map((partido) => ({
        id: partido.id,
        equipo1: partido.equipo_a.nombre,
        equipo2: partido.equipo_b.nombre,
        estado: partido.estado,
        marcador: `${partido.puntosEquipoA} - ${partido.puntosEquipoB}`,
        arbitro1: partido.arbitro1
          ? `${partido.arbitro1.nombres} ${partido.arbitro1.apellidos}`
          : "No disponible",
        arbitro2: partido.arbitro2
          ? `${partido.arbitro2.nombres} ${partido.arbitro2.apellidos}`
          : "No disponible",
        escenario: partido?.escenario?.nombreEscenario,
        fecha: partido.fechaPartido,
        hora: partido.horaInicial,
        idEquipo1: partido.idEquipoA,
        imagenEquipo1: partido.equipo_a.urlImagen,
        imagenEquipo2: partido.equipo_b.urlImagen,
      
      }));
      setPartidos(partidosConDetalles);
    } catch (error) {
      console.error(error);
    }
  }, [idTorneo]);

  useEffect(() => {
    const obtenerEscenarios = async () => {
      try {
        const response = await axios.get(`${BASE_URL}escenarios`);
        setEscenarios(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    obtenerEscenarios();
    obtenerPartidos();
  }, [obtenerPartidos, idTorneo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        idPartido: selectedPartidoId,
        idEscenario: escenarioSeleccionado,
        fecha,
        horaInicial,
        horaFinal,
      };
      await axios.put(`${BASE_URL}update-partido/${selectedPartidoId}`, data);

      obtenerPartidos();
      setModalVisible(false);
    } catch (error) {
      console.error("Error al enviar los datos:", error);
    }
  };

  const filteredPartidos = partidos.filter(
    (partido) =>
      partido?.equipo1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      partido?.equipo2?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      partido?.estado?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handlePlanillar = (idPartido, idEquipo) => {
    setSelectedPartidoId(idPartido);
    setSelectedEquipoId(idEquipo);
    setShowModal(true);
  };

  const handleEstadisticas = (idPartido, idEquipo) => {
    setSelectedPartidoId(idPartido);
    setSelectedEquipoId(idEquipo);
    setShowModalEstadisticas(true);
  };

  const handleEliminar = (partidoId) => {};

  const handleEditar = async (idPartido) => {
    setSelectedPartidoId(idPartido);
    setModalVisible(true); // Abre el modal

    // Obtener los detalles del partido seleccionado
    const partido = partidos.find((p) => p.id === idPartido);
    if (partido) {
      setEscenarioSeleccionado(partido.idEquipo1); // Asigna el escenario del partido (o ajusta según lo necesario)
      setFecha(partido.fecha); // Establece la fecha del partido
      setHoraInicial(partido.hora.split(" - ")[0]); // Establece la hora inicial
      setHoraFinal(partido.hora.split(" - ")[1]); // Establece la hora final
    }
  };

  const displayPartidos = filteredPartidos
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
    .map((partido) => (
      <div key={partido.id} className="partido-card">
        <div className="equipo-section">
          <div className="equipo">
            <img
              src={partido.imagenEquipo1}
              alt={partido.id}
              className="equipo-logo"
            />
            <p className="equipo-nombre">{partido.equipo1}</p>
            <div className="button-container">
              <i
                className="fas fa-clipboard-list fa-2x icon-button"
                title="Planillar"
                onClick={() => handlePlanillar(partido.id, partido.idEquipo1)}
              ></i>
              <i
                className="fas fa-chart-bar fa-2x icon-button"
                title="Estadísticas"
                onClick={() =>
                  handleEstadisticas(partido.id, partido.idEquipo1)
                }
              ></i>
            </div>
          </div>

          <span className="vs-text">VS</span>

          <div className="equipo">
            <img
              src={partido.imagenEquipo2}
              alt={partido.id}
              className="equipo-logo"
            />
            <p className="equipo-nombre">{partido.equipo2}</p>
            <div className="button-container">
              <i
                className="fas fa-clipboard-list fa-2x icon-button"
                title="Planillar"
                onClick={() => handlePlanillar(partido.id, partido.idEquipo2)}
              ></i>
              <i
                className="fas fa-chart-bar fa-2x icon-button"
                title="Estadísticas"
                onClick={() =>
                  handleEstadisticas(partido.id, partido.idEquipo2)
                }
              ></i>
            </div>
          </div>
        </div>

        <div
          className={`estado-partido estado-${partido.estado.toLowerCase()}`}
        >
          <p>{partido.estado}</p>
        </div>
        <div className="marcador-partido">
          <p>{partido.marcador}</p>
        </div>

        <div>
          <p>{partido.fecha}</p>
        </div>

        <div>
          <p>{partido.hora}</p>
        </div>

        {/* Botón Eliminar abajo de la card */}
        <div className="eliminar-button-container">
          <button
            className="btn-eliminar"
            onClick={() => handleEliminar(partido.id)}
          >
            Eliminar
          </button>

          <button
            className="btn-editar" // Clase para el botón Editar
            onClick={() => handleEditar(partido.id)} // Llama a la función para editar
          >
            Editar
          </button>
        </div>
      </div>
    ));

  return (
    <div className="partidos-container">
      <input
        type="text"
        placeholder="Buscar partidos..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />
      <div className="card-container">{displayPartidos}</div>
      <ReactPaginate
        pageCount={Math.ceil(filteredPartidos.length / itemsPerPage)}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
        previousLabel={"< Anterior"}
        nextLabel={"Siguiente >"}
      />

      <ModalUtil
        show={showModal}
        handleClose={handleCloseModal}
        titulo={"Planillar Partido"}
        size="lg"
      >
        <PlanillarPartidoComponent
          idPartido={selectedPartidoId}
          idEquipo={selectedEquipoId}
        />
      </ModalUtil>

      <ModalUtil
        show={showModalEstadisticas}
        handleClose={handleCloseModalEstadisticas}
        titulo={"Estadísticas Partido"}
        size="lg"
      >
        <EstadisticasPartidoComponent
          idPartido={selectedPartidoId}
          idEquipo={selectedEquipoId}
          obtenerPartidos={obtenerPartidos}
        />
      </ModalUtil>

      <Modal show={modalVisible} onHide={() => setModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Actualizar Partido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="escenario">Seleccionar Escenario:</label>
              <select
                id="escenario"
                className="form-control"
                value={escenarioSeleccionado}
                onChange={(e) => setEscenarioSeleccionado(e.target.value)}
                required
              >
                <option value="">Seleccione un escenario</option>
                {escenarios.map((escenario) => (
                  <option key={escenario.id} value={escenario.id}>
                    {escenario.nombreEscenario}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="fecha">Fecha:</label>
              <input
                type="date"
                id="fecha"
                className="form-control"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="horaInicial">Hora Inicial:</label>
              <input
                type="time"
                id="horaInicial"
                className="form-control"
                value={horaInicial}
                onChange={(e) => setHoraInicial(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="horaFinal">Hora Final:</label>
              <input
                type="time"
                id="horaFinal"
                className="form-control"
                value={horaFinal}
                onChange={(e) => setHoraFinal(e.target.value)}
                required
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalVisible(false)}>
            Cerrar
          </Button>
          <Button variant="primary" type="submit" onClick={handleSubmit}>
            Actualizar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export { CardPartidos };
